import React from 'react';
import { Image } from 'antd';

import { ModalTitleSpace, ModalTitleTypography } from './ModalTitle.styles';

interface Props {
    title: string;
    icon?: string;
    style?: React.CSSProperties;
}

const ModalTitle: React.FC<Props> = ({ title, icon, style }) => {
    return (
        <ModalTitleSpace className="title-container" style={style}>
            {icon && <Image src={`src/assets/images/${icon}`} preview={false} />}
            <ModalTitleTypography>
                <strong>{title}</strong>
            </ModalTitleTypography>
        </ModalTitleSpace>
    );
};

export default ModalTitle;
